import { TargetAndTransition } from "framer-motion";

export const buttonWhileHover: TargetAndTransition = { scale: 1.05 };
export const buttonWhileTap: TargetAndTransition = { scale: 0.98 };

export const textRotationAnimation: TargetAndTransition = {
  rotate: 360,
  transition: {
    repeat: Infinity,
    repeatDelay: 0,
    duration: 8,
    ease: "linear",
  },
};
